import { PDFPageProxy } from 'pdfjs-dist';
import { RenderParameters } from 'pdfjs-dist/types/src/display/api';

export type PdfLayerGroup = {
  visible: boolean;
  name?: string;
}

export function convertPdfPageToDataURL(page: PDFPageProxy, scale: number, renderContextOptions?: Partial<RenderParameters>): Promise<ReturnType<HTMLCanvasElement['toDataURL']>> {
  const canvas = document.createElement('canvas');
  const viewport = page.getViewport({ scale });
  const context = canvas.getContext('2d');
  context.imageSmoothingEnabled = false;
  canvas.height = viewport.height;
  canvas.width = viewport.width;

  const renderContext: RenderParameters = {
    canvasContext: context,
    viewport,
    intent: 'display',
    ...renderContextOptions
  };

  return page.render(renderContext).promise.then(() => {
    return canvas.toDataURL();
  });
}

  export function createPdfPageBackdrop(page: PDFPageProxy, scale: number): string {
    const canvas = document.createElement('canvas');
    const viewport = page.getViewport({ scale });    
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0,0,canvas.width,canvas.height);
    return canvas.toDataURL();
}
